module.exports = __webpack_public_path__ + "media/images/icons/icon_share_blue-c1b794e75c507d2699d031166185b14b.svg";